import React, { Fragment } from 'react'
import { Paper, Typography } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import IconButton from '@mui/material/IconButton';
import { v4 as uuidv4 } from 'uuid';
import { useStateIfMounted } from 'use-state-if-mounted';
import enContruccion from '../../../img/enContruccion.jpeg'
import {
    agregarFC_09Accion,
    actualizarFC_09Estatus,
    resetDataFC_09,
    actualizarFC_09SolicitudBorrador,
    agregarFC_09SolicitudBorrador,
    eliminarFC_09AnexoProductoBD,
    actualizarModoBorradorFC_09,
    agregarFC_09AnexoProductos,
    agregarFC_09AnexoProducto,
    editarFC_09AnexoProducto,
    setCambiosFC_09SolicitudNueva,
    setCambiosFC_09SolicitudBorrador,
    actualizarModoCorrecionFC_09,
    actualizarFC_09PaginaActiva,
    ObtenerClientePorLogin,
    ObtenerInstalacionesCliente,
    obtenerContadorDeFechaFolio,
    enviarBorradorFC_09,
    obtenerFC_09Map,
    actualizarFC_09Solicitud, ObtenerInstalacionesRelacionadas
} from '../../../redux/DucksBeneficiario/FC_09Ducks';
import Tooltip from '@mui/material/Tooltip';
import { useDispatch, useSelector } from 'react-redux'
import TextField from '@mui/material/TextField';
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import SaveIcon from '@mui/icons-material/Save';
import FormatClearIcon from '@mui/icons-material/FormatClear';
import ToolBarPaginas from '../../App/ToolBarPaginas';
import InfoBar from '../../App/InfoBar'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import estilos from './FormularioFC09BeneficiarioComponent.module.css';
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../redux/AppDucks';
import TerminosYCondicionesComponent from '../../App/TerminosYCondicionesComponent';
const { useState, useEffect, useRef } = React;
import BotonAtrasSiguienteComponent from '../../App/BotonAtrasSiguienteComponent';
import TablaProducto from '../../App/TablaProducto';
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import Productos from '../../App/Productos';
import Collapsible from 'react-collapsible';
import { ArchivoComponent } from '../../ArchivosComponents/ArchivoComponent';
// import { ObtenerClientePorLogin, ObtenerInstalacionesCliente } from '../../../redux/SolicitudesDucks'
import ModalEnviadoCorrectamente from '../../App/ModalEnviadoCorrectamente';
import { Formik } from 'formik'

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faCheckSquare, faCoffee, faEye, faUsers, faUser, faHandshake, faUserGroup, faUserCheck, faCannabis, faClover, faHandSpock,
    faIndustry, faMoneyBill, faCircleInfo, faPerson, faWineBottle, faDumpster, faBoxOpen, faDumpsterFire,
} from '@fortawesome/free-solid-svg-icons'
library.add(faCheckSquare, faCoffee, faEye, faUsers, faUser, faHandshake, faUserGroup, faUserCheck, faCannabis, faClover, faHandSpock,
    faIndustry, faMoneyBill, faCircleInfo, faPerson, faWineBottle, faDumpster, faBoxOpen, faDumpsterFire)

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ModalCamposObligatorios from '../../App/ModalCamposObligatorios';
import { obtenerSolicitudesWithStatus } from '../../../redux/SolicitudesDucks';
import { obtenerClienteByIdLogin } from '../../../redux/DucksBeneficiario/ClienteDucks';
import DocumentacionFC_09Component from './DocumentacionFC_09Component';
function FormularioFC09BeneficiarioComponent(props) {

    const dispatch = useDispatch()
    const usuario = useSelector(store => store.Usuario)
    const currentUser = useSelector(store => store.Usuario.data)
    let fc_09 = useSelector(store => store.FC_09Solicitud.fc_09)
    let fc_09Productos = useSelector(store => store.FC_09Solicitud.productos)
    let fc_09Map = useSelector(store => store.FC_09Solicitud.fc_09Map)
    let fc_09ProductosMap = useSelector(store => store.FC_09Solicitud.productosMap)
    const modoEdicionBorrador = useSelector(store => store.FC_09Solicitud.modoEdicionBorrador)
    const modoCorreccion = useSelector(store => store.FC_09Solicitud.modoCorreccion)
    let data = useSelector(store => store.FC_09Solicitud.data)
    let dataCliente = useSelector(store => store.FC_09Solicitud.cliente)
    let dataLogin = useSelector(store => store.FC_09Solicitud.dataLogin)
    let marcas = useSelector(store => store.FC_09Solicitud.marcasCliente) //useSelector(store => store.Solicitudes.marcasCliente)
    let instalacionesCliente = useSelector(store => store.FC_09Solicitud.instalacionesCliente)
    let filesMap = useSelector(store => store.FC_09Solicitud.filesMap)
    let filesProductosMap = useSelector(store => store.FC_09Solicitud.filesProductosMap)
    let relacionesCliente = useSelector(store => store.FC_09Solicitud.relacionesCliente)
    let observacionesStatus = useSelector(store => store.FC_09Solicitud.observacionesStatus)

    // const solicitudId = 12
    // const obtener = async (solicitudId) => {
    //     await dispatch(obtenerFC_09Map(solicitudId))
    // }
    const [productos, setProductos] = React.useState([])

    const filesFC_09 = useSelector(store => store.FC_09Solicitud.files)
    const filesProductosFC_09 = useSelector(store => store.FC_09Solicitud.filesProductos)

    // const productosRef = React.useRef(productos)
    const handdleProducto = (objectProducto) => {
        setProductos(prev => [...prev, objectProducto])
    }
    const handdleRemoveProductosPrev = async (objectProducto) => {
        if (objectProducto.data.idfc09_anexoproducto) {
            await dispatch(eliminarFC_09AnexoProductoBD(objectProducto.data.idfc09_anexoproducto))
        }
        const filtro = productos.filter(anexo => anexo.id !== objectProducto.data.id)
        setProductos(filtro)

    }
    const handdleEditProductosPrev = (paramsObjectProducto) => {
        const { ...objectProducto } = paramsObjectProducto
        if (fc_09ProductosMap.length > 0) {
            const filtro = productos.findIndex(anexo => anexo.idfc09_anexoproducto === objectProducto.id)
            let editar = { ...productos[Number(filtro)] }
            const filtroEliminar = productos.filter(anexo => anexo.idfc09_anexoproducto !== objectProducto.id)
            editar.contenidoalcoholico = objectProducto.contenidoalcoholico
            editar.numeroanalisis = objectProducto.numeroanalisis
            editar.numerocertificado = objectProducto.numerocertificado
            editar.marca = objectProducto.marca
            editar.numerolote = objectProducto.numerolote
            editar.contenidonetobotella = objectProducto.contenidonetobotella
            editar.numerobotellas = objectProducto.numerobotellas
            editar.tipoproducto = objectProducto.tipoproducto
            editar.numerocajas = objectProducto.numerocajas
            filtroEliminar.push(editar)
            setProductos(filtroEliminar)
        } else {
            const filtro = productos.findIndex(anexo => anexo.id === objectProducto.id)
            let editar = productos
            const newProductos = []
            for (const i in productos) {
                const { ...restProducto } = productos[i]
                newProductos.push(restProducto)
            }
            newProductos[Number(filtro)].contenidoalcoholico = objectProducto.contenidoalcoholico
            newProductos[Number(filtro)].numeroanalisis = objectProducto.numeroanalisis
            newProductos[Number(filtro)].numerocertificado = objectProducto.numerocertificado
            newProductos[Number(filtro)].marca = objectProducto.marca
            newProductos[Number(filtro)].numerolote = objectProducto.numerolote
            newProductos[Number(filtro)].contenidonetobotella = objectProducto.contenidonetobotella
            newProductos[Number(filtro)].numerobotellas = objectProducto.numerobotellas
            newProductos[Number(filtro)].tipoproducto = objectProducto.tipoproducto
            newProductos[Number(filtro)].numerocajas = objectProducto.numerocajas
            setProductos(newProductos)
        }
    }
    const [validacion, setvalidacion] = React.useState(false)
    const [texto, settexto] = React.useState('')
    const [folioSolicitud, setFolioSolicitud] = useStateIfMounted('')
    const resetValores = (objectProducto) => {
        //setProductos(prev => [...prev, objectProducto])
        setvalidacion(objectProducto.validacion)
    }

    const [alert, setAlert] = useStateIfMounted(false)
    const [errorAgregar, setErrorAgregar] = useStateIfMounted(false)
    const [exito, setExito] = useStateIfMounted(false)

    const idUsuario = usuario.data.user[0].id
    const fechaHoy = moment().format('YYYY-MM-DD')
    const [nombrecliente, setnombrecliente] = useStateIfMounted('')
    //obtener valores para solicitud principal
    const [fechasolicitud, setfechasolicitud] = useStateIfMounted(fechaHoy)
    const fechasolicitudRef = useRef(fechasolicitud)
    const [numerocliente, setnumerocliente] = useStateIfMounted(1)
    const numeroclienteRef = useRef(numerocliente)
    const [entregahologramas, setentregahologramas] = useStateIfMounted(false)
    const entregahologramasRef = useRef(entregahologramas)
    const [emicioncertificadopromocion, setemicioncertificadopromocion] = useStateIfMounted(false)
    const emicioncertificadopromocionRef = useRef(emicioncertificadopromocion)
    const inspeccionenvasadoparaexportaci = true
    const inspeccionenvasadoparaexportaciRef = useRef(inspeccionenvasadoparaexportaci)
    const emicioncertificadonomexportacion = true
    const emicioncertificadonomexportacionRef = useRef(emicioncertificadonomexportacion)
    const [fechavisitapropuesta, setfechavisitapropuesta] = useStateIfMounted(fechaHoy)
    const fechavisitapropuestaRef = useRef(fechavisitapropuesta)
    const [maquilador, setMaquilador] = useStateIfMounted(false)
    const maquiladorRef = useRef(maquilador)
    const [propia, setPropia] = useStateIfMounted(false)
    const propiaRef = useRef(propia)
    const [numerosocio, setNumeroSocio] = useStateIfMounted('')
    const numerosocioRef = useRef(numerosocio)
    const [resposableinstalaciones, setresposableinstalaciones] = useStateIfMounted('')
    const resposableinstalacionesRef = useRef(resposableinstalaciones)
    const [telefono, settelefono] = useStateIfMounted('')
    const telefonoRef = useRef(telefono)
    const [correoelectronico, setcorreoelectronico] = useStateIfMounted('')
    const correoelectronicoRef = useRef(correoelectronico)
    const [domicilioproducto, setdomicilioproducto] = useStateIfMounted('')
    const domicilioProductoRef = useRef(domicilioproducto)
    const [nombreimportador, setnombreimportador] = useStateIfMounted('')
    const nombreImportadorRef = useRef(nombreimportador)
    const [domicilioimportador, setdomicilioimportador] = useStateIfMounted('')
    const domicilioimportadorRef = useRef(domicilioimportador)
    const [paisdestino, setpaisdestino] = useStateIfMounted('')
    const paisdestinoRef = useRef(paisdestino)
    const [idaduanasalida, setidaduanasalida] = useStateIfMounted('')
    const aduanasalidaRef = useRef(idaduanasalida)
    const [observaciones, setobservaciones] = useStateIfMounted('')
    const observacionesRef = useRef(observaciones)
    const [idfc09_solicitudcertificado, setidfc09_solicitudcertificado] = useStateIfMounted(0)
    const idfc09_solicitudcertificadoRef = useRef(idfc09_solicitudcertificado)
    const idestatusdesolicitudes = 2
    const idlogin = idUsuario
    let [terminosYCondiciones, setTerminosYCondiciones] = useStateIfMounted(false)
    const terminosYCondicionesRef = useRef(terminosYCondiciones)
    let contadorFolio = useSelector(store => store.FC_09Solicitud.contadorDeFechaFolio)
    const [folio, setFolio] = useStateIfMounted('')

    React.useEffect(() => {
        var año = moment().format('YY');
        let year = String(año)
        dispatch(obtenerContadorDeFechaFolio(year))
    }, [])

    const setDataResponsable = (data) => {
        // setresposableinstalaciones(target)
        let cadena = data.split('/')
        for (let instalaciones of instalacionesCliente) {
            for (let dato of instalaciones.informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente) {
                if (dato.nombreresponsable === cadena[1] && dato.idresponsabledeinstalacioncliente === Number(cadena[0])) {
                    const telefono = dato.telefono
                    const correoelectronico = dato.correoelectronico
                    const domicilioproducto = instalaciones.informaciongeneralinstalacioncliente.calle + "," +
                        instalaciones.informaciongeneralinstalacioncliente.numerointerior + "," +
                        instalaciones.informaciongeneralinstalacioncliente.numeroexterior + "," +
                        instalaciones.informaciongeneralinstalacioncliente.colonia + "," +
                        instalaciones.informaciongeneralinstalacioncliente.localidad + "," +
                        instalaciones.informaciongeneralinstalacioncliente.codigopostal + "," +
                        instalaciones.informaciongeneralinstalacioncliente.municipio + "," +
                        instalaciones.informaciongeneralinstalacioncliente.estado
                    return { telefono, correoelectronico, domicilioproducto }
                }
            }
        }
        return ''
    }

    React.useEffect(() => {
        if (props.history.location.state) {
            setTerminosYCondiciones(props.history.location.state.terminosYCondiciones)
        }
    }, [props.history.location.state])

    React.useEffect(() => {
        let data = dispatch(ObtenerClientePorLogin({ idlogin: usuario.data.user[0].id }))
    }, [])

    const setTipoInstalacion = (target) => {
        if (target.id === 'maquilador') {
            setMaquilador(true)
            setPropia(false)
        } else {
            if (target.id === 'propia') {
                setPropia(true)
                setMaquilador(false)
            }
        }
    }


    const [docAnalisis, setDocAnalisis] = useState();
    const docAnalisisRef = useRef(docAnalisis)
    const [docOrdenCompra, setOrdenCompra] = useState();
    const docOrdenCompraRef = useRef(docOrdenCompra)
    const [docFactura, setFactura] = useState()
    const docFacturaRef = useRef(docFactura)


    const [productosAEliminar, setProductosAEliminar] = useStateIfMounted([])
    const productosAEliminarRef = useRef(productosAEliminar)

    const [inputFields, setInputFields] = useState([]);
    const productosRef = useRef(inputFields)

    let botonEnviarRegistro = false
    let botonEnviarBorrador = false
    const [botonEnviarCorrecciones, setBotonEnviarCorrecciones] = React.useState(false)

    const activarBotonEnviarForm = () => {
        botonEnviarRegistro = true
    }
    const activarBotonEnviarBorrador = () => {
        botonEnviarBorrador = true
    }
    const activarBotonEnviarCorreciones = () => {
        setBotonEnviarCorrecciones(true)
    }

    let [enviado, setEnviado] = React.useState(false)
    const countFiles = async () => {
        let count = 2
        for (const i in productos) {
            const filesAnalisis = productos[i].numeroanalisis.split(',')
            const filesCertificado = productos[i].numerocertificado.split(',')
            count += filesAnalisis.length + filesCertificado.length + 1
        }
        return count
    }
    const botonRegistrarFC_09 = async (valores) => {

        // const resultCountFiles = await countFiles()
        // const filesAgregados = files.length + filesProductos.length
        // if (filesAgregados >= resultCountFiles) {
        await dispatch(actualizarLoadingApp_true())

        const resCliente = await dispatch(obtenerClienteByIdLogin(currentUser.user[0].id))
        const numeroDeCliente = resCliente.payload?.cliente?.[0]?.numerosocio

        const fechaHoy = moment().format('YYYY-MM-DD')

        let fechaSolicitud = new Date(fechaHoy).toISOString()
        let fechaVisita = new Date(valores.fechavisitapropuesta).toISOString()
        var añoFolio = moment().format('YY');
        var año = moment().format('YY');
        let year = String(año)
        const contadorFolios = await dispatch(obtenerContadorDeFechaFolio(year))
        let consFolio = ''
        if (contadorFolios.payload >= 0 && contadorFolios.payload < 9) consFolio = 'FR-000' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 9 && contadorFolios.payload < 99) consFolio = 'FR-00' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 99 && contadorFolios.payload < 999) consFolio = 'FR-0' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 999 && contadorFolios.payload < 99999) consFolio = 'FR-' + (contadorFolios.payload + 1) + '/' + añoFolio
        let telefono = valores.telefono + ''
        let usuarioData = await dispatch(ObtenerClientePorLogin({ idlogin: usuario.data.user[0].id }))
        const solicitud = {
            fechasolicitud: fechaSolicitud, numerocliente: numeroDeCliente, entregahologramas: valores.entregahologramas, inspeccionenvasadoparaexportaci: valores.inspeccionenvasadoparaexportaci,
            emicioncertificadonomexportacion: valores.emicioncertificadonomexportacion,
            fechavisitapropuesta: fechaVisita, maquilador: valores.maquilador, propia: valores.propia, numerosocio: Number(valores.numerosocio),
            resposableinstalaciones: valores.resposableinstalaciones, telefono: telefono, correoelectronico: valores.correoelectronico,
            domicilioproducto: valores.domicilioproducto, nombreimportador: valores.nombreimportador, domicilioimportador: valores.domicilioimportador,
            paisdestino: valores.paisdestino, observaciones: valores.observaciones, idaduanasalida: Number(valores.idaduanasalida),
            idestatusdesolicitudes: 7, idlogin, emicioncertificadopromocion: valores.emicioncertificadopromocion, folio: consFolio,
            nombrecliente: dataCliente.nombrerazonsocial, revisor: dataLogin.nombre + ' ' + dataLogin.apellidos, tipoinstalacion: valores.tipoinstalacion,
            razonsocialsolicitante: valores.razonsocialsolicitante, noregistradasalida: valores.noregistradasalida
        }
        // let archivos = [
        //     docOrdenCompra,
        //     docFactura
        // ]
        const objetoCompletoFC_09 = {
            solicitud,
            productos,
            files,
            filesProductos
        }
        const resultado = await dispatch(agregarFC_09Accion(objetoCompletoFC_09))
        await dispatch(actualizarLoadingApp_false())
        if (resultado) {
            // setFolioSolicitud(consFolio)
            // setEnviado(true)
            await dispatch(resetDataFC_09())
            functionResetForm.function()
            await dispatch(obtenerSolicitudesWithStatus({ status: 7, idLogin: currentUser.user[0].id }))
            props.history.push('/solicitudes')
        } else {
        }
        // } else {
        //     settexto('')
        //     setvalidacion(true)
        // }

    }
    const guardarBorrador = async (valores) => {
        await dispatch(actualizarLoadingApp_true())

        let fechaSolicitud = new Date(fechasolicitud).toISOString()
        let fechaVisita = new Date(valores.fechavisitapropuesta).toISOString()
        var añoFolio = moment().format('YY');
        var año = moment().format('YY');
        let year = String(año)
        const contadorFolios = await dispatch(obtenerContadorDeFechaFolio(year))
        let consFolio = ''
        if (contadorFolios.payload >= 0 && contadorFolios.payload < 9) consFolio = 'FR-000' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 9 && contadorFolios.payload < 99) consFolio = 'FR-00' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 99 && contadorFolios.payload < 999) consFolio = 'FR-0' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 999 && contadorFolios.payload < 99999) consFolio = 'FR-' + (contadorFolios.payload + 1) + '/' + añoFolio

        let idAduana = Number(valores.idaduanasalida)
        if (idAduana === 0) idAduana = null
        let telefono = valores.telefono + ''
        const solicitud = {
            fechasolicitud: fechaSolicitud, numerocliente: null, entregahologramas: valores.entregahologramas, inspeccionenvasadoparaexportaci: valores.inspeccionenvasadoparaexportaci,
            emicioncertificadonomexportacion: valores.emicioncertificadonomexportacion,
            fechavisitapropuesta: fechaVisita, maquilador: valores.maquilador, propia: valores.propia, numerosocio: Number(valores.numerosocio),
            resposableinstalaciones: valores.resposableinstalaciones, telefono: telefono, correoelectronico: valores.correoelectronico,
            domicilioproducto: valores.domicilioproducto, nombreimportador: valores.nombreimportador, domicilioimportador: valores.domicilioimportador,
            paisdestino: valores.paisdestino, observaciones: valores.observaciones, idaduanasalida: idAduana,
            idestatusdesolicitudes: 1, idlogin, emicioncertificadopromocion: valores.emicioncertificadopromocion, folio: consFolio,
            nombrecliente: dataCliente.nombrerazonsocial, revisor: dataLogin.nombre + ' ' + dataLogin.apellidos, tipoinstalacion: valores.tipoinstalacion,
            razonsocialsolicitante: valores.razonsocialsolicitante, noregistradasalida: valores.noregistradasalida
        }
        // let archivos = [
        //     docOrdenCompra,
        //     docFactura
        // ]
        const objetoCompletoFC_09 = {
            solicitud,
            productosAGuardar: productos,
        }
        const resultado = await dispatch(agregarFC_09SolicitudBorrador(objetoCompletoFC_09))

        await dispatch(actualizarLoadingApp_false())
        if (resultado) {
            await dispatch(resetDataFC_09())
            await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: currentUser.user[0].id }))
            props.history.push('/solicitudes')
        } else {
        }
    }

    const actualizarBorrador = async (valores) => {
        await dispatch(actualizarLoadingApp_true())

        let fechaSolicitud = new Date(fechasolicitud).toISOString()
        let fechaVisita = new Date(valores?.fechavisitapropuesta).toISOString()

        let idAduana = Number(valores.idaduanasalida)
        if (idAduana === 0) idAduana = null
        let telefono = valores.telefono + ''
        const solicitud = {
            idfc09_solicitudcertificado: data.idfc09_solicitudcertificado, fechasolicitud: fechaSolicitud, numerocliente: null, entregahologramas: valores.entregahologramas, inspeccionenvasadoparaexportaci: valores.inspeccionenvasadoparaexportaci,
            emicioncertificadonomexportacion: valores.emicioncertificadonomexportacion,
            fechavisitapropuesta: fechaVisita, maquilador: valores.maquilador, propia: valores.propia, numerosocio: Number(valores.numerosocio),
            resposableinstalaciones: valores.resposableinstalaciones, telefono: telefono, correoelectronico: valores.correoelectronico,
            domicilioproducto: valores.domicilioproducto, nombreimportador: valores.nombreimportador, domicilioimportador: valores.domicilioimportador,
            paisdestino: valores.paisdestino, observaciones: valores.observaciones, idaduanasalida: idAduana,
            idestatusdesolicitudes: 1, idlogin, emicioncertificadopromocion: valores.emicioncertificadopromocion,
            revisor: dataLogin.nombre + ' ' + dataLogin.apellidos, tipoinstalacion: valores.tipoinstalacion,
            razonsocialsolicitante: valores.razonsocialsolicitante, noregistradasalida: valores.noregistradasalida
            // nombrecliente:nombrecliente

        }
        // let archivos = [
        //     docOrdenCompra,
        //     docFactura
        // ]
        const objetoCompletoFC_09 = {
            solicitud,
            productos,
        }
        const resultado = await dispatch(actualizarFC_09SolicitudBorrador(objetoCompletoFC_09))

        await dispatch(actualizarLoadingApp_false())
        if (resultado) {
            await dispatch(resetDataFC_09())
            await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: currentUser.user[0].id }))
            props.history.push('/solicitudes')
        } else {
        }
    }

    const enviarBorrador = async (valores) => {
        const resultCountFiles = await countFiles()
        const filesAgregados = files.length + filesProductos.length
        // if (filesAgregados >= resultCountFiles) {
        await dispatch(actualizarLoadingApp_true())
        const resCliente = await dispatch(obtenerClienteByIdLogin(currentUser.user[0].id))
        const numeroDeCliente = resCliente.payload?.cliente?.[0]?.numerosocio

        let fechaSolicitud = new Date(fechaHoy).toISOString()
        let fechaVisita = new Date(valores?.fechavisitapropuesta).toISOString()

        let idAduana = Number(valores.idaduanasalida)
        if (idAduana === 0) idAduana = null
        let telefono = valores.telefono + ''
        const solicitud = {
            idfc09_solicitudcertificado: data.idfc09_solicitudcertificado, fechasolicitud: fechaSolicitud, numerocliente: numeroDeCliente, entregahologramas: valores.entregahologramas, inspeccionenvasadoparaexportaci: valores.inspeccionenvasadoparaexportaci,
            emicioncertificadonomexportacion: valores.emicioncertificadonomexportacion,
            fechavisitapropuesta: fechaVisita, maquilador: valores.maquilador, propia: valores.propia, numerosocio: Number(valores.numerosocio),
            resposableinstalaciones: valores.resposableinstalaciones, telefono: telefono, correoelectronico: valores.correoelectronico,
            domicilioproducto: valores.domicilioproducto, nombreimportador: valores.nombreimportador, domicilioimportador: valores.domicilioimportador,
            paisdestino: valores.paisdestino, observaciones: valores.observaciones, idaduanasalida: idAduana,
            idestatusdesolicitudes: 1, idlogin, emicioncertificadopromocion: valores.emicioncertificadopromocion,
            nombrecliente: dataCliente.nombrerazonsocial, revisor: dataLogin.nombre + ' ' + dataLogin.apellidos,
            tipoinstalacion: valores.tipoinstalacion, razonsocialsolicitante: valores.razonsocialsolicitante, noregistradasalida: valores.noregistradasalida
        }
        // let archivos = [
        //     docOrdenCompra,
        //     docFactura
        // ]
        const objetoCompletoFC_09 = {
            solicitud,
            productos,
            files,
            filesProductos
        }
        const resultado = await dispatch(enviarBorradorFC_09(objetoCompletoFC_09))

        await dispatch(actualizarLoadingApp_false())
        if (resultado) {
            const idSolicitud = data.idfc09_solicitudcertificado
            const estatusNuevo = 7
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_09 = 4
            const tabla = tablaFC_09
            await dispatch(actualizarFC_09Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: data.folio } }
            ))
            await dispatch(resetDataFC_09())
            functionResetForm.function()
            await dispatch(obtenerSolicitudesWithStatus({ status: 7, idLogin: currentUser.user[0].id }))
            props.history.push('/solicitudes')
        } else {
        }
        // } else {
        //     settexto('')
        //     setvalidacion(true)
        // }
    }
    const enviarCorreccion = async (valores) => {
        // await dispatch(actualizarLoadingApp_true())
        let fechaSolicitud = new Date(fechasolicitud)?.toISOString()
        // let fechaVisita = new Date(valores.fechavisitapropuesta).toISOString()
        let fechaVisita = new Date(valores.fechavisitapropuesta)?.toISOString()
        let idAduana = Number(valores.idaduanasalida)
        if (idAduana === 0) idAduana = null
        // else idAduana = Number(valores.idaduanasalida)
        let telefono = valores.telefono + ''
        const solicitud = {
            idfc09_solicitudcertificado: data.idfc09_solicitudcertificado, fechasolicitud: fechaSolicitud,
            entregahologramas: valores.entregahologramas,
            inspeccionenvasadoparaexportaci: valores.inspeccionenvasadoparaexportaci,
            emicioncertificadonomexportacion: valores.emicioncertificadonomexportacion,
            fechavisitapropuesta: fechaVisita,
            maquilador: valores.maquilador, propia: valores.propia, numerosocio: Number(valores.numerosocio),
            resposableinstalaciones: valores.resposableinstalaciones, telefono: telefono, correoelectronico: valores.correoelectronico,
            domicilioproducto: valores.domicilioproducto, nombreimportador: valores.nombreimportador, domicilioimportador: valores.domicilioimportador,
            paisdestino: valores.paisdestino, observaciones: valores.observaciones,
            idaduanasalida: idAduana,
            idestatusdesolicitudes: 6, idlogin, emicioncertificadopromocion: valores.emicioncertificadopromocion,
            revisor: dataLogin.nombre + ' ' + dataLogin.apellidos, tipoinstalacion: valores.tipoinstalacion,
            razonsocialsolicitante: valores.razonsocialsolicitante, noregistradasalida: valores.noregistradasalida
            // nombrecliente:nombrecliente
        }
        const objetoCompletoFC_09 = {
            solicitud,
            productos,
            files,
            filesProductos
        }
        await dispatch(actualizarFC_09Solicitud(objetoCompletoFC_09))
        const idSolicitud = data.idfc09_solicitudcertificado
        const estatusNuevo = 6
        const idCliente = null //Se necesita obtener del cliente, a traves del login 
        const tablaFC_09 = 4
        const tabla = tablaFC_09
        await dispatch(actualizarFC_09Estatus(
            { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: data.folio } }
        ))
        await dispatch(resetDataFC_09())
        handleResetAllPropertys()
        /////// await dispatch(obtenerSolicitudesWithStatus({ status: 3, idLogin: currentUser.user[0].id }))
        await dispatch(actualizarLoadingApp_false())
        ///////// await dispatch(obtenerSolicitudesWithStatus({ status: 6, idLogin: currentUser.user[0].id }))
        ////// props.history.push('/solicitudes')
        props.history.push('/solicitudes')
    }

    const handleResetAllPropertys = () => {
        setfechasolicitud(fechaHoy)
        setnumerocliente('')
        setentregahologramas(false)
        // setinspeccionenvasadoparaexportaci(true)
        // setemicioncertificadonomexportacion(true)
        setemicioncertificadopromocion(false)
        setfechavisitapropuesta(fechaHoy)
        setPropia(false)
        setMaquilador(false)
        setresposableinstalaciones('')
        settelefono('')
        setcorreoelectronico('')
        setdomicilioproducto('')
        setnombreimportador('')
        setdomicilioimportador('')
        setpaisdestino('')
        setidaduanasalida("0")
        setobservaciones('')
        setidfc09_solicitudcertificado()
        setProductos([])
        setFile([])
        setFileProductos([])
        handleCloseModal()

        dispatch(resetDataFC_09())
    }

    // const noActualizarBorrador = useRef(true)

    React.useEffect(() => {
        if (!(JSON.stringify({}) === JSON.stringify(data))) {
            fc_09 = data
        }
        if (!(JSON.stringify({}) == JSON.stringify(fc_09))) {
            // setOrdenCompra(fc_09.docOrdenCompra)
            // setFactura(fc_09.docFactura)
            if (fc_09Productos.data) {
                if (fc_09Productos.data.data) {
                    setProductos(fc_09Productos.data.data)
                } else {
                    setProductos(fc_09Productos.data)
                }
            }
            if (!(JSON.stringify([]) == JSON.stringify(instalacionesRelacionadas))) {
                const nuevoProducto = instalacionesRelacionadas.filter(field => field.informaciongeneralinstalacioncliente.alias === fc_09.tipoinstalacion)
                setResposableRelacionados(nuevoProducto[0].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente)
                if (fc_09Map?.numerosociocheck || fc_09Map?.domicilioproductocheck) setActiveInstalaciones(false)
            }
            setFolioSolicitud(fc_09.folio)
            setnombrecliente(dataCliente.nombrerazonsocial)
            let fechasolicitud = moment(fc_09.fechasolicitud).format('YYYY-MM-DD')
            let fechavisitapropuesta = moment(fc_09.fechavisitapropuesta).format('YYYY-MM-DD')
            setentregahologramas(fc_09.entregahologramas)
            setemicioncertificadopromocion(fc_09.emicioncertificadopromocion)

            setfechavisitapropuesta(fechavisitapropuesta)
            setMaquilador(fc_09.maquilador)
            setPropia(fc_09.propia)
            setNumeroSocio(fc_09.numerosocio)
            setresposableinstalaciones(fc_09.resposableinstalaciones)
            setcorreoelectronico(fc_09.correoelectronico)
            settelefono(fc_09.telefono)
            setdomicilioproducto(fc_09.domicilioproducto)
            setnombreimportador(fc_09.nombreimportador)
            setdomicilioimportador(fc_09.domicilioimportador)
            setpaisdestino(fc_09.paisdestino)
            setidaduanasalida(fc_09.idaduanasalida)
            setobservaciones(fc_09.observaciones)
            setidfc09_solicitudcertificado(fc_09.idfc09_solicitudcertificado)
            setnumerocliente(fc_09.numerocliente)
        }
    }, [fc_09, data])

    // React.useEffect(() => {
    //     return () => {
    //         if (noActualizarBorrador.current === true) {
    //             handleSaveFC_09State()
    //         }
    //     }
    // }, [])


    // React.useEffect(() => {
    //     handleSetAllPropertysRef()
    // }, [
    //     fechasolicitud,
    //     numerocliente,
    //     resposableinstalaciones,
    //     telefono,
    //     correoelectronico,
    //     domicilioproducto,
    //     entregahologramas,
    //     inspeccionenvasadoparaexportaci,
    //     emicioncertificadonomexportacion,
    //     emicioncertificadopromocion,
    //     fechavisitapropuesta,
    //     nombreimportador,
    //     domicilioimportador,
    //     paisdestino,
    //     idaduanasalida,
    //     observaciones,
    //     idfc09_solicitudcertificado,
    //     files,
    //     productos,
    //     filesProductos
    // ])

    React.useEffect(() => {
        if (fc_09Productos.data) {
            if (fc_09Productos.data.data) {
                setProductos(fc_09Productos.data.data)
            } else {
                setProductos(fc_09Productos.data)
            }
        }
    }, [fc_09Productos])
    const [functionResetForm, setFunctionResetForm] = React.useState()
    const [functionSubmitForm, setFunctionSubmitForm] = React.useState()

    const [openModal, setOpenModal] = React.useState(false);
    const [titleModal, setTitleModal] = React.useState('');
    const [bodyModal, setBodyModal] = React.useState('')
    const [accion, setAccion] = React.useState('')
    const [dataModal, setDataModal] = React.useState('')
    const handleOpenModal = (data) => {

        setTitleModal(data.title)
        setBodyModal(data.body)
        setAccion(data.accion)
        setOpenModal(true)
        setDataModal(data.data)
    }
    const handleCloseModal = () => {
        setTitleModal('')
        setBodyModal('')
        setAccion('')
        setOpenModal(false)
        setDataModal('')
    }

    const modalComponent = () => {
        return (
            <div>
                <Modal
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <center>{titleModal}</center>
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }} component="h2">
                            <p className={`${estilos.bodyModal}`}>{bodyModal}</p>
                            <br /> <center><strong>¿Desea continuar?</strong></center>
                        </Typography>
                        <br />
                        <div className='row'>
                            <button className='btn btn-success' onClick={() => {
                                switch (accion) {
                                    case 'guardarBorrador':
                                        // botonGuardarCambiosFC_09(1)
                                        guardarBorrador(dataModal)
                                        break;
                                    case 'actualizarBorrador':
                                        actualizarBorrador(dataModal)
                                        break;
                                    case 'enviarBorrador':
                                        enviarBorrador()
                                        break;
                                    case 'reiniciarFormato':
                                        handleResetAllPropertys()
                                        functionResetForm.function()
                                        break;
                                    case 'enviarCorreccion':
                                        activarBotonEnviarCorreciones()
                                        functionSubmitForm.function()
                                        // enviarCorreccion()
                                        break;
                                    case 'enviarSolicitudFC_09':
                                        activarBotonEnviarForm()
                                        functionSubmitForm.function()
                                        break;
                                    case 'enviarSolicitudBorradorFC_09':
                                        activarBotonEnviarBorrador()
                                        functionSubmitForm.function()
                                        break;
                                    default:
                                        break;
                                }
                            }
                            }>CONTINUAR</button>
                        </div>
                    </Box>
                </Modal>
            </div>
        )
    }

    const botonEnviarBorradorFC_09 = async () => {
        handleOpenModal({
            title: `¡Advertencia!`,
            body: `Está a punto de enviar su solicitud al personal de atencion al cliente, 
            ya no podrá seguir editando esta solicitud.`,
            accion: 'enviarBorrador'
        })
    }

    const botonGuardarComoBorrador = async (valores) => {
        if (modoEdicionBorrador) {
            handleOpenModal({
                title: `¡Advertencia!`,
                body: `Está a punto de actualizar este borrador de solicitud.
                Los archivos de la sección final no se guardarán, puesto que es un borrador del formulario.`,
                accion: 'actualizarBorrador',
                data: valores
            })
        } else {
            handleOpenModal({
                title: `¡Advertencia!`,
                body: `Está a punto de guardar esta solicitud en su apartado de borradores
                Los archivos de la seccion final no se guardarán puesto que es un borrador del formulario`,
                accion: 'guardarBorrador',
                data: valores
            })
        }
    }

    const botonReiniciarFormato = () => {
        handleOpenModal({
            title: `¡Advertencia!`,
            body: `Está a punto de reiniciar el formato, esta acción eliminará toda la información
                y no se podrá revertir.`,
            accion: 'reiniciarFormato'
        })
    }
    const botonEnviarCorreccionesFC_09 = async () => {
        handleOpenModal({
            title: `¡Advertencia!`,
            body: `Está a punto de enviar las correcciones al personal de atencion al cliente, 
            ya no podrá seguir corrigiendo esta solicitud.`,
            accion: 'enviarCorreccion'
        })
    }


    const botonEnviarSolicitudFC_09 = async () => {
        handleOpenModal({
            title: `¡Advertencia!`,
            body: `Está a punto de finalizar el formulario, posteriormente deberá adjuntar la documentación 
            correspondiente para enviar la solicitud al personal de atencion al cliente.`,
            accion: 'enviarSolicitudFC_09'
        })
    }


    const botonEnviarSolicitudBorradorFC_09 = async () => {
        handleOpenModal({
            title: `¡Advertencia!`,
            body: `Está a punto de finalizar el formulario, posteriormente deberá adjuntar la documentación 
            correspondiente para enviar la solicitud al personal de atencion al cliente.`,
            accion: 'enviarSolicitudBorradorFC_09'
        })
    }
    // const enviarBorrador = async () => {
    //     await dispatch(actualizarLoadingApp_true())
    //     await botonGuardarCambiosFC_09(2)

    //     const idSolicitud = data.idfc09_solicitudcertificado
    //     const estatusNuevo = 2
    //     const idCliente = null //Se necesita obtener del cliente, a traves del login 
    //     const tablaFC_09 = 4
    //     const tabla = tablaFC_09
    //     await dispatch(actualizarFC_09Estatus(
    //         { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente } }
    //     ))
    //     await dispatch(resetDataFC_09())
    //     handleResetAllPropertys()
    //     await dispatch(actualizarLoadingApp_false())
    //     props.history.push('/solicitudes')
    // }





    const botonGuardarCambiosFC_09 = async (accion) => {
        const solicitud = {
            fechasolicitud, numerocliente, resposableinstalaciones, telefono, correoelectronico,
            // calle, numeroexterior,
            // numerointerior, codigopostal, colonia, localidad, delegacionmunicipio, estado, 
            entregahologramas, inspeccionenvasadoparaexportaci,
            emicioncertificadonomexportacion,
            //  emicioncertificadonomexportacionparapromocion, 
            fechavisitapropuesta, nombreimportador, domicilio, paisdestino, aduanasalida,
            observaciones, idlogin, idestatusdesolicitudes: 1
        }

        //props.history.push('/fc_05')
        let productosAGuardar = []
        let productosParaActualizar = []
        for (const inputField of inputFields) {
            //let id = inputField.id
            if (inputField.idfc09_solicitudcertificado === undefined) {
                let contenidoalcoholico = inputField.contenidoalcoholico
                let numeroanalisislaboratorio = inputField.numeroanalisislaboratorio
                let numerocertificadonommezcalgrane = inputField.numerocertificadonommezcalgrane
                let marca = inputField.marca
                let numeroloteenvasado = inputField.numeroloteenvasado
                let contenidonetobotella = inputField.contenidonetobotella
                let numerobotellas = inputField.numerobotellas
                let numerocajas = inputField.numerocajas

                const objetoProducto = {
                    contenidoalcoholico: contenidoalcoholico,
                    numeroanalisislaboratorio: numeroanalisislaboratorio,
                    numerocertificadonommezcalgrane: numerocertificadonommezcalgrane,
                    marca: marca,
                    numeroloteenvasado: numeroloteenvasado,
                    contenidonetobotella: contenidonetobotella,
                    numerobotellas: numerobotellas,
                    numerocajas: numerocajas
                }
                productosAGuardar.push(objetoProducto)
            } else {
                const { id, ...rest } = inputField
                productosParaActualizar.push(rest)
            }
        }
        const objetoCompletoFC_09 = {
            solicitud,
            productosAGuardar
        }
        if (modoEdicionBorrador) {
            solicitud.idfc09_solicitudcertificado = idfc09_solicitudcertificado

            if (accion === 2) {

                let archivos = [
                    docOrdenCompra,
                    docFactura
                ]
                const objetoCompletoFC_09 = {
                    solicitud,
                    productosAGuardar,
                    productosParaActualizar,
                    productosAEliminar,
                    archivos
                }
                await dispatch(actualizarFC_09SolicitudBorrador(objetoCompletoFC_09))
                return
            }

            const objetoCompletoFC_09ParaActualizar = {
                solicitud,
                productosAGuardar,
                productosParaActualizar,
                productosAEliminar,
            }
            await dispatch(actualizarFC_09SolicitudBorrador(objetoCompletoFC_09ParaActualizar))

            if (accion === 1) {
                await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: currentUser.user[0].id }))
                props.history.push('/solicitudes')
            }
            return
        }
        const res = await dispatch(agregarFC_09SolicitudBorrador(objetoCompletoFC_09))
        await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: currentUser.user[0].id }))
        props.history.push('/solicitudes')

    }


    const salirModoEdicionBorrador = async () => {
        dispatch(actualizarModoBorradorFC_09(false))
        dispatch(resetDataFC_09())
        handleResetAllPropertys()
    }
    const salirModoCorreccion = () => {
        dispatch(actualizarModoCorrecionFC_09(false))
        dispatch(resetDataFC_09())
        handleResetAllPropertys()
    }

    // const cambioProducto = (data) => {
    //     dispatch(editarFC_09AnexoProducto(data))
    //     /*if(modoEdicionBorrador){
    //         dispatch(editarFC_09AnexoProducto(data))
    //     }else{
    //         const nuevoProducto = inputFields.filter(field => field.id === data.id)
    //         nuevoProducto[0][data.campo] = data.valor
    //         setInputFields([...inputFields]);
    //     }*/
    // }

    // const deleteProducto = (inputField) => {
    //     if (inputField.idfc09_anexoproducto) {
    //         dispatch(eliminarFC_09AnexoProductoBD(inputField.idfc09_anexoproducto))
    //     }
    //     const fields = inputFields.filter(fields => fields.id !== inputField.id)
    //     setInputFields(fields)
    //     dispatch(agregarFC_09AnexoProductos({ data: fields }))
    // }

    // const handleAddFields = () => {
    //     let anexo = {
    //         id: uuidv4(), contenidoalcoholico: '', numeroanalisislaboratorio: '', numerocertificadonommezcalgrane: '',
    //         marca: '', numeroloteenvasado: '', contenidonetobotella: '', numerobotellas: '', numerocajas: '', fileProducto: null
    //     }
    //     if (modoEdicionBorrador) {
    //         dispatch(agregarFC_09AnexoProducto(anexo))
    //     } else {
    //         setInputFields([...inputFields, anexo])
    //         let anexos = [...inputFields, anexo]
    //         dispatch(agregarFC_09AnexoProductos({ data: anexos }))
    //     }
    // };

    const [paginas, setPaginas] = useStateIfMounted([1, 2, 3, 4])
    const paginaActiva = useSelector(store => store.FC_09Solicitud.paginaActiva)
    const [nombresParaPaginas, setNombresParaPaginas] = useStateIfMounted(['Datos generales', 'Datos Importador', 'Productos', 'Documentación'])
    const paginaSiguiente = async (valores) => {

        if (productos.length === 0 && nombresParaPaginas[paginaActiva - 1] === 'Productos') {
            settexto('o por lo menos un producto')
            setvalidacion(true)
        } else {
            const result = await validation(valores)
            if (JSON.stringify(result) !== '{}') {
                settexto('')
                setvalidacion(true)
            } else {
                dispatch(actualizarFC_09PaginaActiva(paginaActiva + 1))
            }
        }

    }
    const paginaAnterior = async () => {
        dispatch(actualizarFC_09PaginaActiva(paginaActiva - 1))
    }

    const [files, setFile] = React.useState([])
    const filesRef = React.useRef(files)
    const handdleFile = (objectFile) => {
        setFile(prev => [...prev, objectFile])
    }

    const handdleRemovePrev = (objectFile) => {
        if (objectFile) {
            const newFiles = files.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                setFile(newFiles)
            }
        }
    }



    React.useEffect(() => {
        if (filesFC_09?.data) {
            let newFiles = []
            for (const file of filesFC_09.data) {
                const { ...newFile } = file
                newFiles.push(newFile)
            }
            setFile(newFiles)
        }

        if (filesProductosFC_09?.data) {
            let newFiles = []
            for (const file of filesProductosFC_09.data) {
                const { ...newFile } = file
                newFiles.push(newFile)
            }
            setFileProductos(newFiles)
        }

    }, [fc_09, data])
    const FilesGenerales = () => {
        return (
            <div>
                <Collapsible trigger="Documentación general" className='mb-3'>
                    <div className={`mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                        <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={'DGOC'} tabla={"FC_09_anexos"} filesMap={filesMap}
                            textLabel={`Orden de compra: `} textoTooltip='Del importador o invitación a la feria o exposición en el extranjero.' />
                        <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={'DGFP'} tabla={"FC_09_anexos"} filesMap={filesMap}
                            textLabel={`Factura o proforma: `} textoTooltip='En caso de que el producto se exporte con fines de promoción, entregar factura sin valor comercial.' />

                    </div>
                </Collapsible>
            </div>
        )
    }
    const [filesProductos, setFileProductos] = React.useState([])
    const filesProductosRef = React.useRef(filesProductos)
    const handdleFileProducto = (objectFile) => {
        setFileProductos(prev => [...prev, objectFile])
    }

    const handdleRemoveProductoPrev = (objectFile) => {
        if (objectFile) {
            const newFiles = filesProductos.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                setFileProductos(newFiles)
            }
        }
    }
    const FilesProductos = () => {
        let file = []
        let certificadoAnalisis = []
        return (
            <div>
                <Collapsible trigger="Documentación de productos" className='mb-3'>
                    {productos.map((anexo, index) => (

                        <div className={`mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                            <label classname='text-center'>Producto:{index + 1}</label>
                            {file = anexo.numeroanalisis.split(',')}
                            {certificadoAnalisis = anexo.numerocertificado.split(',')}
                            {file.map((analisis, i) => (
                                <ArchivoComponent api={{ handdleFile: handdleFileProducto, handdleRemovePrev: handdleRemoveProductoPrev, files: filesProductos }} tabla={"FC_09_anexos"}
                                    textLabel={`Análisis de laboratorio ${analisis} :`} idAnexo={anexo.id} id={`DPAL${index}${i}`} textoTooltip='' filesMap={filesProductosMap} />
                            ))}
                            {certificadoAnalisis.map((certificado, i) => (
                                <ArchivoComponent api={{ handdleFile: handdleFileProducto, handdleRemovePrev: handdleRemoveProductoPrev, files: filesProductos }} tabla={"FC_09_anexos"}
                                    textLabel={`Certificado NOM de producto a granel ${certificado}: `} idAnexo={anexo.id} id={`DPCA${index}${i}`} textoTooltip='' filesMap={filesProductosMap} />
                            ))}
                            <ArchivoComponent api={{ handdleFile: handdleFileProducto, handdleRemovePrev: handdleRemoveProductoPrev, files: filesProductos }} tabla={"FC_09_anexos"}
                                textLabel={`Etiqueta aprobada: `} idAnexo={anexo.id} id={`DPEP${index}`} textoTooltip='' filesMap={filesProductosMap} />
                        </div>
                    ))}

                </Collapsible>
            </div>
        )
    }
    const dataInicialFC_09 = {
        entregahologramas: false,
        emicioncertificadonomexportacion: true,
        emicioncertificadopromocion: false,
        inspeccionenvasadoparaexportaci: true,
        fechavisitapropuesta: fechaHoy,
        maquilador: false,
        propia: false,
        numerosocio: '',
        resposableinstalaciones: '',
        correoelectronico: '',
        telefono: '',
        domicilioproducto: '',
        nombreimportador: '',
        domicilioimportador: '',
        paisdestino: '',
        idaduanasalida: '0',
        observaciones: '',
    }

    function comprobarEmail(correo) {
        let emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let isEmailAceptadoFlag = false;
        let isExtensionAceptadaFlag = false;
        if (!correo) return false
        if (correo.match(emailRegex)) {

            isEmailAceptadoFlag = true;
            isExtensionAceptadaFlag = true;

            if (isEmailAceptadoFlag === true && isExtensionAceptadaFlag === true) {
                return true
            } else {
                return false
            }

        } else {
            return false
        }

    }
    const validation = values => {
        let errores = {};
        const textoError = 'Campo obligratorio'

        if (paginaActiva === 1) {
            if (!values.fechavisitapropuesta) { errores.fechavisitapropuesta = textoError }
            /*if (values.maquilador) {
                if(!values.tipoInstalacion) errores.tipoInstalacion = 'Seleccione el tipo de instalación'
            }*/
            if (values.maquilador === true) {
                if (!values.numerosocio) { errores.numerosocio = textoError }
            }
            if (!values.emicioncertificadonomexportacion && !values.emicioncertificadopromocion) errores.emicioncertificado = 'Debe de seleccionar un certificado para emitir'
            if (values.noregistradasalida === true) {
                if (!values.razonsocialsolicitante) { errores.razonsocialsolicitante = textoError }
            }
            if (!values.resposableinstalaciones) { errores.resposableinstalaciones = textoError }
            if (!values.correoelectronico) { errores.correoelectronico = textoError }
            else {
                let valido = comprobarEmail(values.correoelectronico)
                if (!valido) errores.correoelectronico = 'Verifica la estructura de tu correo electrónico'
            }
            if (!values.telefono) { errores.telefono = textoError }
            else if ((values.telefono + '').length !== 10) errores.telefono = 'Debe contener 10 digitos'
            if (!values.domicilioproducto) { errores.domicilioproducto = textoError }
            else {
                let longitudDomicilio = values.domicilioproducto.split(',')
                if (longitudDomicilio.length !== 8) { errores.domicilioproducto = "Ingresar el domicilio completo separado por una coma, (calle,número interior,número exterior,colonia,localidad,código postal,municipio,estado)" }
            }

        } else if (paginaActiva === 2) {
            if (!values.nombreimportador) { errores.nombreimportador = textoError }
            if (!values.domicilioimportador) { errores.domicilioimportador = textoError }
            if (!values.paisdestino) { errores.paisdestino = textoError }
            if (!values.idaduanasalida) { errores.idaduanasalida = textoError }
            else if (values.idaduanasalida === '0') { errores.idaduanasalida = textoError }
            //if (!values.observaciones) { errores.observaciones = textoError }
        }

        return errores;
    }

    let instalacionesRelacionadas = useSelector(store => store.FC_09Solicitud.instalacionesRelacionadas)
    let [activeinstalaciones, setActiveInstalaciones] = React.useState(true)
    let [numSocioEncontrado, setNumSocioEncontrado] = React.useState(false)
    const buscarSocio = async (numerosocio) => {
        const filtro = relacionesCliente.filter(relacion => relacion.productor === numerosocio || relacion.envasado === numerosocio)

        if (filtro.length > 0) {
            let instalacionesRelacionadas = await dispatch(ObtenerInstalacionesRelacionadas(numerosocio))
            setActiveInstalaciones(false)
            setNumSocioEncontrado(false)
        } else {
            setNumSocioEncontrado(true)
            setActiveInstalaciones(true)
        }
    }
    let [resposableRelacionados, setResposableRelacionados] = React.useState([])
    let [activeresponsable, setActiveResponsable] = React.useState(true)
    const setDomicilio = (target) => {
        let instalaciones = { ...instalacionesRelacionadas }
        for (let dato in instalaciones) {
            if (instalaciones[dato].informaciongeneralinstalacioncliente.alias === target) {
                //const telefono = dato.telefono
                setResposableRelacionados(instalaciones[dato].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente)
                //const correoelectronico = dato.correoelectronico
                const domicilioproducto = instalaciones[dato].informaciongeneralinstalacioncliente.calle + "," +
                    instalaciones[dato].informaciongeneralinstalacioncliente.numerointerior + "," +
                    instalaciones[dato].informaciongeneralinstalacioncliente.numeroexterior + "," +
                    instalaciones[dato].informaciongeneralinstalacioncliente.colonia + "," +
                    instalaciones[dato].informaciongeneralinstalacioncliente.localidad + "," +
                    instalaciones[dato].informaciongeneralinstalacioncliente.codigopostal + "," +
                    instalaciones[dato].informaciongeneralinstalacioncliente.municipio + "," +
                    instalaciones[dato].informaciongeneralinstalacioncliente.estado

                setActiveResponsable(false)
                return domicilioproducto
            }
        }
        return ''
    }
    const setResponsables = (target) => {
        for (let dato in resposableRelacionados) {
            if (resposableRelacionados[dato].nombreresponsable === target) {
                const telefono = resposableRelacionados[dato].telefono
                const correoelectronico = resposableRelacionados[dato].correoelectronico
                return { telefono, correoelectronico }
            }
        }
        return ''
    }

    return (
        <Fragment>
            {/*<img src={enContruccion} style={{marginLeft:'10%', background:'black', width:'1200px', marginTop:'1%',textAlign:'center'}} disabled={true}></img>*/}
            <Formik

                initialValues={
                    // dataInicialFC_09
                    fc_09
                }

                validate={validation}
                onSubmit={(valores) => {
                    if (botonEnviarRegistro) {
                        botonRegistrarFC_09(valores)
                    }
                    if (botonEnviarBorrador) {
                        enviarBorrador(valores)
                    }
                    if (botonEnviarCorrecciones) {
                        enviarCorreccion(valores)
                    }
                }}
            >
                {({ values, handleChange, handleSubmit, handleBlur, errors, touched, resetForm, submitForm, setValues }) => (
                    <form onSubmit={(e) => handleSubmit(e)}>
                        <div className='container2'>
                            <div className='row mt-3'>
                                <div className='row'>
                                    <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-12 marginsitoTop">
                                        <InfoBar nombreSolicitud={'Solicitud de emisión de certificado NOM para exportación'} />

                                        {
                                            modoEdicionBorrador &&
                                            <div className='d-grid gap-2'>
                                                <button className='btn btn-warning mt-1 mb-1'
                                                    onClick={salirModoEdicionBorrador}>Salir modo edicion</button>
                                            </div>
                                        }

                                    </div>
                                    {
                                        !modoCorreccion &&
                                        <div className="col-xs-12 col-sm-12 col-md-5 col-lg-2 col-xl-2 marginsitoTop">
                                            <Fragment >
                                                <IconButton sx={{ color: '#c88b3e' }} size="large" edge="end"
                                                    aria-label="Guardar cambios" aria-haspopup="true" onClick={() => { botonGuardarComoBorrador(values), setFunctionResetForm({ function: resetForm }) }}
                                                >
                                                    <SaveIcon />
                                                    {
                                                        modoEdicionBorrador ? (
                                                            <div className="badge text-dark textoModal text-center">
                                                                Guardar cambios en borrador
                                                            </div>) : (
                                                            <div className="badge text-dark textoModal text-center">
                                                                Guardar como borrador
                                                            </div>
                                                        )
                                                    }
                                                </IconButton>
                                            </Fragment>
                                        </div>
                                    }
                                    <div className="col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 text-center">
                                        <h1></h1>
                                    </div>
                                    {
                                        !modoCorreccion &&
                                        <div className="col-xs-12 col-sm-12 col-md-2 col-lg-1 col-xl-1 text-center marginsitoTop">
                                            <Fragment>
                                                <IconButton sx={{ color: '#c88b3e' }} size="large" edge="end"
                                                    aria-label="Reiniciar formato" aria-haspopup="true" color="error" onClick={() => { botonReiniciarFormato(), setFunctionResetForm({ function: resetForm }) }}
                                                >
                                                    <FormatClearIcon />
                                                    <div className="badge text-dark textoNormalbadge text-dark textoModal text-center">Reiniciar Formato </div>
                                                </IconButton>
                                            </Fragment>
                                        </div>
                                    }

                                </div>
                            </div>
                            {
                                paginaActiva === 1 ?
                                    (
                                        <Fragment>
                                            {
                                                modoCorreccion &&
                                                <div className='text-center'>
                                                    {
                                                        observacionesStatus.observacionesGeneral !== 0 ?
                                                            <h6><p style={{ color: 'red' }}><strong>Este apartado tiene observaciones</strong></p></h6>
                                                            :
                                                            <h6><p style={{ color: 'green' }}><strong>Este apartado no tuvo observaciones</strong></p></h6>
                                                    }
                                                </div>
                                            }
                                            <div className='row align-items-center'>
                                                <div className='row'>
                                                    <div className='row'>
                                                        <h6 className={`text-center ${estilos.labelNaranja}`}>SERVICIO SOLICITADO</h6>
                                                    </div>
                                                    <div className={`row  ${estilos.divSoloBorderNaranja}`}>
                                                        <div className='col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3'>
                                                            <input className={`form-check-input me-1 ${fc_09Map?.entregahologramascheck !== undefined ? (fc_09Map?.entregahologramascheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                type="checkbox" id="checkbox1"
                                                                // checked={entregahologramas} onChange={e => setentregahologramas(e.target.checked)} 
                                                                align='left'
                                                                name="entregahologramas"
                                                                value={values.entregahologramas}
                                                                checked={values.entregahologramas}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            <Tooltip title={`Los hologramas se entregaran después de 24 horas de aceptación de la solicitud, previa constatación
                                                del cumplimiento del producto con el apartado 4.3 de la NOM-070, en vigor.
                                                En caso de que el producto ya cuente con los hologramas no seleccionar este recuadro.`} arrow>
                                                                <label className="form-check-label me-5" htmlFor="flexCheckChecked">
                                                                    Entrega de
                                                                </label>

                                                            </Tooltip>
                                                            <label className="form-check-label me-5" htmlFor="flexCheckChecked">
                                                                hologramas
                                                            </label>
                                                            <br /><span className='text-danger'>{fc_09Map?.entregahologramascheck === true ? fc_09Map?.entregahologramas : ''}</span>
                                                            {touched.entregahologramas && errors.entregahologramas && <div className="text-danger">{errors.entregahologramas}</div>}
                                                        </div>
                                                        <div className='col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4'>
                                                            <input className={`form-check-input me-1 ${fc_09Map?.emicioncertificadonomexportacioncheck !== undefined ? (fc_09Map?.emicioncertificadonomexportacioncheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                                checked={values.emicioncertificadonomexportacion}
                                                                name="emicioncertificadonomexportacion"
                                                                value={values.emicioncertificadonomexportacion}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur} />
                                                            <Tooltip title={`El certificado se emitirá una vez que se reciba el Dictamen de Cumplimiento
                                                con la NOM de la Unidad de inspección (previa inspección del envasado y del
                                                holograma de certificación).`} arrow>
                                                                <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                                                    Emisión del certificado
                                                                </label>
                                                            </Tooltip><br />
                                                            <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                                                NOM de exportación
                                                            </label>
                                                        </div>
                                                        <div className='col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5'>

                                                            <input className={`form-check-input me-1 
                                                ${fc_09Map?.emicioncertificadopromocioncheck !== undefined ? (fc_09Map?.emicioncertificadopromocioncheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox" id=""
                                                                // checked={emicioncertificadopromocion} onChange={e => setemicioncertificadopromocion(e.target.checked)} 
                                                                name="emicioncertificadopromocion"
                                                                value={values.emicioncertificadopromocion}
                                                                checked={values.emicioncertificadopromocion}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            <label className="form-check-label me-5" htmlFor="flexCheckChecked">
                                                                Emisión de certificado
                                                            </label><br />
                                                            <label className="form-check-label me-5" htmlFor="flexCheckChecked">
                                                                NOM de exportación para promoción
                                                            </label>
                                                            <br /><span className='text-danger'>{fc_09Map?.emicioncertificadopromocioncheck === true ? fc_09Map?.emicioncertificadopromocion : ''}</span>
                                                            {touched.emicioncertificadopromocion && errors.emicioncertificadopromocion && <div className="text-danger">{errors.emicioncertificadopromocion}</div>}
                                                        </div>
                                                        {errors.emicioncertificado && <div className="text-danger">{errors.emicioncertificado}</div>}

                                                        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                            <br />
                                                            <input className={`form-check-input me-1 ${fc_09Map?.inspeccionenvasadoparaexportacicheck !== undefined ? (fc_09Map?.inspeccionenvasadoparaexportacicheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox" id=""
                                                                checked={values.inspeccionenvasadoparaexportaci}
                                                                name="inspeccionenvasadoparaexportaci"
                                                                value={values.inspeccionenvasadoparaexportaci}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                disabled
                                                            />
                                                            <label className="form-check-label me-5" htmlFor="flexCheckChecked">
                                                                Inspección durante el
                                                            </label><br />
                                                            <label className="form-check-label me-5" htmlFor="flexCheckChecked">
                                                                envasado para exportación
                                                            </label>
                                                        </div>
                                                        <div className='col-xs-12 col-sm-12 col-md-1 col-lg-1 col-xl-1'></div>
                                                        {values.inspeccionenvasadoparaexportaci &&

                                                            <div className='col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4'>
                                                                <br />
                                                                <div className="form-floating mb-3">

                                                                    <input type="date" className={`form-control ${fc_09Map.fechavisitapropuestacheck !== undefined ?
                                                                        (fc_09Map?.fechavisitapropuestacheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                        id="" placeholder='Fecha propuesta' min={fechaHoy}
                                                                        // value={fechavisitapropuesta} onChange={e => setfechavisitapropuesta(e.target.value)} 
                                                                        name="fechavisitapropuesta"
                                                                        value={values.fechavisitapropuesta}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    <label htmlFor='floatingInput'>Fecha de visita propuesta</label>
                                                                    <span className='text-danger'>{fc_09Map?.fechavisitapropuestacheck === true ? fc_09Map?.fechavisitapropuesta : ''}</span>
                                                                    {touched.fechavisitapropuesta && errors.fechavisitapropuesta && <div className="text-danger">{errors.fechavisitapropuesta}</div>}
                                                                </div>
                                                            </div>}

                                                    </div>
                                                </div>

                                                <div className='row justify-content-start'>
                                                    <br />
                                                    <div className={`row mb-2 mt-2 ${estilos.labelNaranja}`}>
                                                        <h6 className='text-center'><b>DOMICILIO DONDE SE ENCUENTRA EL PRODUCTO</b></h6>

                                                    </div>
                                                    <div className='col-xs-12 col-sm-12 col-md-3 col-xl-3 col-xxl-3'>
                                                        <label htmlFor='floatingInput'>¿Tipo de instalación?</label>
                                                    </div>
                                                    <div className='col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2'>
                                                        <input className={`form-check-input me-1 ${fc_09Map.maquiladorcheck !== undefined ?
                                                            (fc_09Map?.maquiladorcheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                            // checked={maquilador} id='maquilador'
                                                            // onChange={e => setTipoInstalacion(e.target)} 
                                                            checked={values.maquilador} id='maquilador'
                                                            name="maquilador"
                                                            // value={values.maquilador}
                                                            onChange={e => {
                                                                const { ...newValues } = values
                                                                newValues.maquilador = e.target.checked
                                                                newValues.propia = false
                                                                newValues.noregistradasalida = false
                                                                newValues.resposableinstalaciones = ''
                                                                newValues.correoelectronico = ''
                                                                newValues.telefono = ''
                                                                newValues.domicilioproducto = ''
                                                                newValues.numerosocio = ''
                                                                newValues.razonsocialsolicitante = ''
                                                                setValues(newValues)
                                                            }}
                                                            onBlur={handleBlur}
                                                        />

                                                        <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                                            Maquilador
                                                        </label>
                                                    </div>
                                                    <div className='col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2'>
                                                        <input className={`form-check-input me-1 ${fc_09Map.propiacheck !== undefined ?
                                                            (fc_09Map?.propiacheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                            checked={values.propia} id='propia'
                                                            name="propia"
                                                            onChange={e => {
                                                                const { ...newValues } = values
                                                                newValues.propia = e.target.checked
                                                                newValues.maquilador = false
                                                                newValues.noregistradasalida = false
                                                                newValues.resposableinstalaciones = ''
                                                                newValues.correoelectronico = ''
                                                                newValues.telefono = ''
                                                                newValues.domicilioproducto = ''
                                                                newValues.numerosocio = ''
                                                                newValues.razonsocialsolicitante = ''
                                                                setValues(newValues)
                                                            }}
                                                            onBlur={handleBlur}
                                                        />
                                                        <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                                            Propia
                                                        </label>
                                                    </div>
                                                    <div className='col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2'>
                                                        <input className={`form-check-input me-1 ${fc_09Map.noregistradasalidacheck !== undefined ?
                                                            (fc_09Map?.noregistradasalidacheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                            checked={values.noregistradasalida} id='noregistradasalida'
                                                            name="noregistradasalida"
                                                            onChange={e => {
                                                                const { ...newValues } = values
                                                                newValues.noregistradasalida = e.target.checked
                                                                newValues.maquilador = false
                                                                newValues.propia = false
                                                                newValues.resposableinstalaciones = ''
                                                                newValues.correoelectronico = ''
                                                                newValues.telefono = ''
                                                                newValues.domicilioproducto = ''
                                                                newValues.numerosocio = ''
                                                                setValues(newValues)
                                                            }}
                                                            onBlur={handleBlur}
                                                        />
                                                        <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                                            Empresa no registrada
                                                        </label>
                                                    </div>
                                                    {/*(touched.maquilador || touched.propia || touched.noregistradasalida) && errors.tipoInstalacion && <div className="text-danger">{errors.tipoInstalacion}</div>*/}
                                                    <br />

                                                    {values.propia &&
                                                        <Fragment >
                                                            <br />
                                                            <div className='col-md-6'>
                                                                <div className="form-floating mb-3">
                                                                    <select className={`form-select ${fc_09Map.resposableinstalacionescheck !== undefined ?
                                                                        (fc_09Map?.resposableinstalacionescheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                        // value={resposableinstalaciones}
                                                                        // onChange={e => setResponsable(e.target.value)}

                                                                        name="resposableinstalaciones"
                                                                        value={values.resposableinstalaciones}
                                                                        onChange={e => {
                                                                            const result = setDataResponsable(e.target.value)
                                                                            const { ...newValues } = values
                                                                            newValues.resposableinstalaciones = e.target.value
                                                                            if (result !== '') {
                                                                                newValues.correoelectronico = result.correoelectronico
                                                                                newValues.telefono = result.telefono
                                                                                newValues.domicilioproducto = result.domicilioproducto
                                                                            }
                                                                            setValues(newValues)
                                                                        }}
                                                                        onBlur={handleBlur}
                                                                    >
                                                                        <option value="">Seleccione un responsable</option>
                                                                        {
                                                                            instalacionesCliente?.map((instalaciones, index) => (
                                                                                instalaciones.informaciongeneralinstalacioncliente?.responsablesdeinstalacioncliente.map((opcion, index) => (
                                                                                    <option value={`${opcion.idresponsabledeinstalacioncliente + '/' + opcion.nombreresponsable}`} >{`${instalaciones.informaciongeneralinstalacioncliente.instalacionnumero + '.-'}${instalaciones.idtipoanexo === 1 ? 'Unidad de producción: ' : instalaciones.idtipoanexo === 2 ? 'Unidad de envasado: ' : 'Unidad de Almacen: '}${opcion.nombreresponsable}`}</option>
                                                                                ))
                                                                            ))
                                                                        }
                                                                    </select>
                                                                    <label htmlFor='floatingInput'>Responsable de instalaciones</label>
                                                                    <span className='text-danger'>{fc_09Map?.resposableinstalacionescheck === true ? fc_09Map?.resposableinstalaciones : ''}</span>
                                                                    {touched.resposableinstalaciones && errors.resposableinstalaciones && <div className="text-danger">{errors.resposableinstalaciones}</div>}
                                                                </div>
                                                            </div>
                                                            <div className='col-xs-12 col-sm-12 col-md-4 col-xl-4 col-xxl-4'>
                                                                <div className="form-floating mb-3">
                                                                    <input type="text" className={`form-control ${fc_09Map.correoelectronicocheck !== undefined ? (
                                                                        fc_09Map?.correoelectronicocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='ejemplo@gmail.com'
                                                                        // value={correoelectronico} onChange={e => setcorreoelectronico(e.target.value)} 
                                                                        name="correoelectronico"
                                                                        value={values.correoelectronico}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    <label htmlFor='floatingInput'>Correo electrónico</label>
                                                                    <span className='text-danger'>{fc_09Map?.correoelectronicocheck ? fc_09Map?.correoelectronico : ''}</span>
                                                                    {touched.correoelectronico && errors.correoelectronico && <div className="text-danger">{errors.correoelectronico}</div>}
                                                                </div>
                                                            </div>

                                                            <div className='col-xs-12 col-sm-12 col-md-2 col-xl-2 col-xxl-2'>
                                                                <div className="form-floating mb-3">
                                                                    <input type="number" min='0' className={`form-control ${fc_09Map.telefonocheck !== undefined ? (
                                                                        fc_09Map?.telefonocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='Telefono'
                                                                        // value={telefono} onChange={e => settelefono(e.target.value)} 
                                                                        name="telefono"
                                                                        value={values.telefono}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        onWheel={event => event.currentTarget.blur()}
                                                                    />
                                                                    <label htmlFor='floatingInput'>Teléfono</label>
                                                                    <span className='text-danger'>{fc_09Map?.telefonocheck ? fc_09Map?.telefono : ''}</span>
                                                                    {touched.telefono && errors.telefono && <div className="text-danger">{errors.telefono}</div>}
                                                                </div>
                                                            </div>
                                                            <div className='col-xs-12 col-sm-12 col-md-12 col-xl-12 col-xxl-12'>
                                                                <div className="form-floating mb-3">
                                                                    <input type="text" className={`form-control ${fc_09Map.domicilioproductocheck !== undefined ? (
                                                                        fc_09Map?.domicilioproductocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='Domicilio Completo'
                                                                        // value={domicilioproducto} onChange={e => setdomicilioproducto(e.target.value)} 
                                                                        name="domicilioproducto"
                                                                        value={values.domicilioproducto}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    <label htmlFor='floatingInput'>Domicilio completo</label>
                                                                    <span className='text-danger'>{fc_09Map?.domicilioproductocheck ? fc_09Map?.domicilioproducto : ''}</span>
                                                                    {touched.domicilioproducto && errors.domicilioproducto && <div className="text-danger">{errors.domicilioproducto}</div>}
                                                                </div>
                                                            </div>
                                                        </Fragment>
                                                    }
                                                    <br />
                                                    {
                                                        values.maquilador &&
                                                        <Fragment>
                                                            <div className='col-xs-12 col-sm-12 col-md-3 col-xl-3 col-xxl-3'></div>
                                                            <div className='col-xs-12 col-sm-12 col-md-5 col-xl-5 col-xxl-5'>
                                                                <div className="form-floating mb-3">
                                                                    <input type="number" className={`form-control ${fc_09Map.numerosociocheck !== undefined ? (
                                                                        fc_09Map?.numerosociocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                        id="floatingInput" placeholder='ejemplo@gmail.com'
                                                                        // value={numerosocio} 
                                                                        // onChange={e => { e.target.value.length <= 4 ? (setNumeroSocio(e.target.valueAsNumber)) : '' }}
                                                                        name="numerosocio"
                                                                        value={values.numerosocio}
                                                                        onChange={e => {
                                                                            //if (e.target.value.length < 5) {
                                                                            const { ...newValues } = values
                                                                            newValues.numerosocio = e.target.value
                                                                            newValues.domicilioproducto = ''
                                                                            newValues.telefono = ''
                                                                            newValues.correoelectronico = ''
                                                                            newValues.resposableinstalaciones = ''
                                                                            newValues.tipoinstalacion = ''
                                                                            setResposableRelacionados([])
                                                                            setActiveInstalaciones(true)
                                                                            setActiveResponsable(true)
                                                                            setValues(newValues)
                                                                            //}
                                                                        }}
                                                                        onBlur={handleBlur}
                                                                        onWheel={event => event.currentTarget.blur()}
                                                                    />
                                                                    <label htmlFor='floatingInput'>Número de socio</label>
                                                                    <span className='text-danger'>{fc_09Map?.numerosociocheck ? fc_09Map?.numerosocio : ''}</span>
                                                                    {
                                                                        numSocioEncontrado && <span className='text-danger'>Número de socio no encontrado en sus relaciones</span>
                                                                    }
                                                                    {touched.numerosocio && errors.numerosocio && <div className="text-danger">{errors.numerosocio}</div>}
                                                                </div>
                                                            </div>

                                                            <div className='col-xs-12 col-sm-12 col-md-1 col-xl-1 col-xxl-1'>
                                                                <button type="submit" className={'btn btn-success'} onClick={() => { buscarSocio(values.numerosocio) }} disabled={fc_09Map.numerosociocheck == false ? true : false}>Buscar</button>
                                                            </div>

                                                            <div className='col-md-6'>
                                                                <div className="form-floating mb-3">
                                                                    <select className={`form-select ${fc_09Map.domicilioproductocheck !== undefined ? (
                                                                        fc_09Map?.domicilioproductocheck ? 'inputDenegado' : 'inputValidado') : fc_09Map.numerosociocheck !== undefined ? (
                                                                            fc_09Map?.numerosociocheck ? 'inputDenegado' : 'inputValidado') : ''}`}

                                                                        name="tipoinstalacion"
                                                                        value={values.tipoinstalacion}
                                                                        onChange={e => {
                                                                            const result = setDomicilio(e.target.value)
                                                                            const { ...newValues } = values
                                                                            newValues.tipoinstalacion = e.target.value
                                                                            if (result !== '') {
                                                                                newValues.domicilioproducto = result
                                                                            } else {
                                                                                newValues.domicilioproducto = result
                                                                                newValues.telefono = ''
                                                                                newValues.correoelectronico = ''
                                                                                newValues.resposableinstalaciones = ''
                                                                                setActiveResponsable(true)
                                                                            }
                                                                            setValues(newValues)
                                                                        }}
                                                                        onBlur={handleBlur}
                                                                        disabled={activeinstalaciones}
                                                                    >
                                                                        <option value="">Seleccione una instalación</option>
                                                                        {
                                                                            instalacionesRelacionadas?.map((opcion, index) => (
                                                                                <option value={`${opcion.informaciongeneralinstalacioncliente.alias}`}>
                                                                                    {`${opcion.idtipoanexo === 1 ? 'Unidad Producción: ' + opcion.informaciongeneralinstalacioncliente.alias : opcion.idtipoanexo === 2 ? 'Unidad de Envasado: ' + opcion.informaciongeneralinstalacioncliente.alias : opcion.idtipoanexo === 3 ? 'Unidad Almacen: ' + opcion.informaciongeneralinstalacioncliente.alias : ''}`}</option>
                                                                            ))
                                                                        }
                                                                    </select>
                                                                    <label htmlFor='floatingInput'>Tipo de instalación</label>
                                                                    <span className='text-danger'>{fc_09Map?.numerosociocheck ? fc_09Map?.numerosocio : ''}</span>
                                                                    {touched.tipoinstalacion && errors.tipoinstalacion && <div className="text-danger">{errors.tipoinstalacion}</div>}
                                                                </div>
                                                            </div>

                                                            <div className='col-md-6'>
                                                                <div className="form-floating mb-3">
                                                                    <select className={`form-select ${fc_09Map.resposableinstalacionescheck !== undefined ?
                                                                        (fc_09Map?.resposableinstalacionescheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}

                                                                        name="resposableinstalaciones"
                                                                        value={values.resposableinstalaciones}
                                                                        onChange={e => {
                                                                            const result = setResponsables(e.target.value)
                                                                            const { ...newValues } = values
                                                                            newValues.resposableinstalaciones = e.target.value
                                                                            if (result !== '') {
                                                                                newValues.correoelectronico = result.correoelectronico
                                                                                newValues.telefono = result.telefono
                                                                            } else {
                                                                                newValues.correoelectronico = ''
                                                                                newValues.telefono = ''
                                                                            }
                                                                            setValues(newValues)
                                                                        }}
                                                                        onBlur={handleBlur}
                                                                        disabled={activeresponsable}
                                                                    >
                                                                        <option value="">Seleccione un responsable</option>
                                                                        {
                                                                            resposableRelacionados.map((opcion, index) => (
                                                                                <option value={`${opcion.nombreresponsable}`} >{`${opcion.nombreresponsable}`}</option>
                                                                            ))
                                                                        }
                                                                    </select>
                                                                    <label htmlFor='floatingInput'>Responsable de instalacion</label>
                                                                    <span className='text-danger'>{fc_09Map?.resposableinstalacionescheck === true ? fc_09Map?.resposableinstalaciones : ''}</span>
                                                                    {touched.resposableinstalaciones && errors.resposableinstalaciones && <div className="text-danger">{errors.resposableinstalaciones}</div>}
                                                                </div>
                                                            </div>
                                                            <div className='col-xs-12 col-sm-12 col-md-3 col-xl-3 col-xxl-3'>
                                                                <div className="form-floating mb-3">
                                                                    <input type="text" className={`form-control ${fc_09Map.resposableinstalacionescheck !== undefined ?
                                                                        (fc_09Map?.resposableinstalacionescheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                        id="floatingInput" placeholder='ejemplo@gmail.com'
                                                                        // value={correoelectronico} onChange={e => setcorreoelectronico(e.target.value)}
                                                                        name="correoelectronico"
                                                                        value={values.correoelectronico}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    <label htmlFor='floatingInput'>Correo electrónico</label>
                                                                    <span className='text-danger'>{fc_09Map?.correoelectronicocheck ? fc_09Map?.correoelectronico : ''}</span>
                                                                    {touched.correoelectronico && errors.correoelectronico && <div className="text-danger">{errors.correoelectronico}</div>}
                                                                </div>
                                                            </div>

                                                            <div className='col-xs-12 col-sm-12 col-md-3 col-xl-3 col-xxl-3'>
                                                                <div className="form-floating mb-3">
                                                                    <input type="number" min='0' className={`form-control ${fc_09Map.resposableinstalacionescheck !== undefined ?
                                                                        (fc_09Map?.resposableinstalacionescheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                        id="floatingInput" placeholder='Telefono'
                                                                        // value={telefono} onChange={e => settelefono(e.target.value)}
                                                                        name="telefono"
                                                                        value={values.telefono}
                                                                        onChange={e => {
                                                                            if (e.target.value.length < 11) {
                                                                                const { ...newValues } = values
                                                                                newValues.telefono = e.target.value
                                                                                setValues(newValues)
                                                                            }
                                                                        }}
                                                                        onBlur={handleBlur}
                                                                        onWheel={event => event.currentTarget.blur()}
                                                                    />
                                                                    <label htmlFor='floatingInput'>Teléfono</label>
                                                                    <span className='text-danger'>{fc_09Map?.telefonocheck ? fc_09Map?.telefono : ''}</span>
                                                                    {touched.telefono && errors.telefono && <div className="text-danger">{errors.telefono}</div>}
                                                                </div>
                                                            </div>
                                                            <div className='col-xs-12 col-sm-12 col-md-12 col-xl-12 col-xxl-12'>
                                                                <div className="form-floating mb-3">
                                                                    <input type="text" className={`form-control ${fc_09Map.domicilioproductocheck !== undefined ? (
                                                                        fc_09Map?.domicilioproductocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='Domicilio Completo'
                                                                        // value={domicilioproducto} onChange={e => setdomicilioproducto(e.target.value)}
                                                                        name="domicilioproducto"
                                                                        value={values.domicilioproducto}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    <label htmlFor='floatingInput'>Domicilio completo</label>
                                                                    <span className='text-danger'>{fc_09Map?.domicilioproductocheck ? fc_09Map?.domicilioproducto : ''}</span>
                                                                    {touched.domicilioproducto && errors.domicilioproducto && <div className="text-danger">{errors.domicilioproducto}</div>}
                                                                </div>
                                                            </div>
                                                        </Fragment>
                                                    }
                                                    {values.noregistradasalida &&
                                                        <Fragment>
                                                            <br />
                                                            <div className='col-md-12'>
                                                                <div className="form-floating mb-3">
                                                                    <input type="text" className={`form-control ${fc_09Map.razonsocialsolicitantecheck !== undefined ? (
                                                                        fc_09Map?.razonsocialsolicitantecheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                        placeholder='razonsocialsolicitante'
                                                                        name="razonsocialsolicitante"
                                                                        value={values.razonsocialsolicitante}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    <label htmlFor="floatingInput">Razón social</label>
                                                                    <br />
                                                                    <span className='text-danger'>{fc_09Map?.razonsocialsolicitantecheck ? fc_09Map?.razonsocialsolicitante : ''}</span>
                                                                    {touched.razonsocialsolicitante && errors.razonsocialsolicitante && <div className="text-danger">{errors.razonsocialsolicitante}</div>}
                                                                </div>
                                                            </div>
                                                            <div className='col-md-6'>
                                                                <div className="form-floating mb-3">
                                                                    <input type="text" className={`form-control ${fc_09Map.resposableinstalacionescheck !== undefined ? (
                                                                        fc_09Map?.resposableinstalacionescheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                        placeholder='resposableinstalaciones'
                                                                        name="resposableinstalaciones"
                                                                        value={values.resposableinstalaciones}
                                                                        //onChange={handleChange}
                                                                        onChange={e => {
                                                                            const newValues = { ...values };
                                                                            newValues.resposableinstalaciones = e.target.value;
                                                                            newValues.responsabletraslado = e.target.value;
                                                                            setValues(newValues);
                                                                        }}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    <label htmlFor="floatingInput">Responsable de instalación</label>
                                                                    <span className='text-danger'>{fc_09Map?.resposableinstalacionescheck ? fc_09Map?.resposableinstalaciones : ''}</span>
                                                                    {touched.resposableinstalaciones && errors.resposableinstalaciones && <div className="text-danger">{errors.resposableinstalaciones}</div>}
                                                                </div>
                                                            </div>
                                                            <div className='col-md-3'>
                                                                <div className="form-floating mb-3">
                                                                    <input type="number" className={`form-control ${fc_09Map.telefonocheck !== undefined ? (
                                                                        fc_09Map?.telefonocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                        placeholder='telefono'
                                                                        name="telefono"
                                                                        value={values.telefono}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    <label htmlFor="floatingInput">Teléfono</label>
                                                                    <span className='text-danger'>{fc_09Map?.telefonocheck ? fc_09Map?.telefono : ''}</span>
                                                                    {touched.telefono && errors.telefono && <div className="text-danger">{errors.telefono}</div>}
                                                                </div>
                                                            </div>
                                                            <div className='col-md-3'>
                                                                <div className="form-floating mb-3">
                                                                    <input type="text" className={`form-control ${fc_09Map.correoelectronicocheck !== undefined ? (
                                                                        fc_09Map?.correoelectronicocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                        placeholder='correoelectronico'
                                                                        name="correoelectronico"
                                                                        value={values.correoelectronico}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    <label htmlFor="floatingInput">Correo electrónico</label>
                                                                    <span className='text-danger'>{fc_09Map?.correoelectronicocheck ? fc_09Map?.correoelectronico : ''}</span>
                                                                    {touched.correoelectronico && errors.correoelectronico && <div className="text-danger">{errors.correoelectronico}</div>}
                                                                </div>
                                                            </div>
                                                            <div className='col-md-12'>
                                                                <div className="form-floating mb-3">
                                                                    <input type="text" className={`form-control ${fc_09Map.domicilioproductocheck !== undefined ? (
                                                                        fc_09Map?.domicilioproductocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                        placeholder='domicilioproducto'
                                                                        name="domicilioproducto"
                                                                        value={values.domicilioproducto}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    <label htmlFor="floatingInput">Domicilio Completo</label>
                                                                    <br />
                                                                    <span className='text-danger'>{fc_09Map?.domicilioproductocheck ? fc_09Map?.domicilioproducto : ''}</span>
                                                                    {
                                                                        values.propiasalida !== true &&
                                                                        <div className="text-danger">Ingresar el domicilio completo (calle,número interior,número exterior,colonia,localidad,código postal,municipio,estado)</div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </Fragment>
                                                    }
                                                </div>
                                            </div>
                                        </Fragment>
                                    ) : paginaActiva === 2 ?
                                        (
                                            <Fragment>
                                                {
                                                    modoCorreccion &&
                                                    <div className='text-center'>
                                                        {
                                                            observacionesStatus.observacionesImportador !== 0 ?
                                                                <h6><p style={{ color: 'red' }}><strong>Este apartado tiene observaciones</strong></p></h6>
                                                                :
                                                                <h6><p style={{ color: 'green' }}><strong>Este apartado no tuvo observaciones</strong></p></h6>
                                                        }
                                                    </div>
                                                }
                                                <div className='row align-items-center'>
                                                    <div className='row mb-2'>
                                                        <Tooltip title={`Los datos deben aparecer tal cual se indican en la factura y orden de compra`} arrow>
                                                            <h6 className={`text-center ${estilos.labelNaranja}`}>INFORMACIÓN DEL IMPORTADOR</h6>
                                                        </Tooltip>
                                                    </div>
                                                    <div className='col-xs-12 col-sm-12 col-md-6 col-xl-6 col-xxl-6'>
                                                        <div className="form-floating mb-3">
                                                            <input type="text" className={`form-control ${fc_09Map.nombreimportadorcheck !== undefined ? (
                                                                fc_09Map?.nombreimportadorcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='Nombre'
                                                                // value={nombreimportador} onChange={e => setnombreimportador(e.target.value)}
                                                                name="nombreimportador"
                                                                value={values.nombreimportador}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            <label htmlFor='floatingInput'>Nombre</label>
                                                            <span className='text-danger'>{fc_09Map?.nombreimportadorcheck ? fc_09Map?.nombreimportador : ''}</span>
                                                            {touched.nombreimportador && errors.nombreimportador && <div className="text-danger">{errors.nombreimportador}</div>}
                                                        </div>
                                                    </div>
                                                    <div className='col-xs-12 col-sm-12 col-md-6 col-xl-6 col-xxl-6'>
                                                        <div className="form-floating mb-3">
                                                            <input type="text" className={`form-control ${fc_09Map.domicilioimportadorcheck !== undefined ? (
                                                                fc_09Map?.domicilioimportadorcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='Domicilio'
                                                                // value={domicilioimportador} onChange={e => setdomicilioimportador(e.target.value)} 
                                                                name="domicilioimportador"
                                                                value={values.domicilioimportador}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            <label htmlFor='floatingInput'>Domicilio</label>
                                                            <span className='text-danger'>{fc_09Map?.domicilioimportadorcheck ? fc_09Map?.domicilioimportador : ''}</span>
                                                            {touched.domicilioimportador && errors.domicilioimportador && <div className="text-danger">{errors.domicilioimportador}</div>}
                                                        </div>
                                                    </div>
                                                    <div className='col-xs-12 col-sm-12 col-md-6 col-xl-6 col-xxl-6'>
                                                        <div className="form-floating mb-3">
                                                            <input type="text" className={`form-control ${fc_09Map.paisdestinocheck !== undefined ? (
                                                                fc_09Map?.paisdestinocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='pais destino'
                                                                // value={paisdestino} onChange={e => setpaisdestino(e.target.value)} 
                                                                name="paisdestino"
                                                                value={values.paisdestino}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            <label htmlFor='floatingInput'>Pais destino</label>
                                                            <span className='text-danger'>{fc_09Map?.paisdestinocheck ? fc_09Map?.paisdestino : ''}</span>
                                                            {touched.paisdestino && errors.paisdestino && <div className="text-danger">{errors.paisdestino}</div>}
                                                        </div>
                                                    </div>
                                                    <div className='col-xs-12 col-sm-12 col-md-6 col-xl-6 col-xxl-6'>
                                                        <div className="form-floating mb-3">
                                                            <select
                                                                // onChange={e => setidaduanasalida(e.target.value)}
                                                                // value={idaduanasalida}
                                                                name="idaduanasalida"
                                                                value={values.idaduanasalida}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                className={`form-select ${fc_09Map.idaduanasalidacheck !== undefined ? (
                                                                    fc_09Map?.idaduanasalidacheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                            >
                                                                <option value="0" >ADUANA SALIDA</option>
                                                                <option value="1">AEROPUERTO INTERNACIONAL DE LA CIUDAD DE MÉXICO</option>
                                                                <option value="2">AGUASCALIENTES, AGUASCALIENTES</option>
                                                                <option value="3">ALTAMIRA, TAMAULIPAS</option>
                                                                <option value="4">CIUDAD HIDALGO, CHIAPAS</option>
                                                                <option value="5">CIUDAD JUÁREZ, CHIHUAHUA</option>
                                                                <option value="6">COLOMBIA, NUEVO LEÓN</option>
                                                                <option value="7">GUADALAJARA, JALISCO</option>
                                                                <option value="8">GUANAJUATO, GUANAJUATO</option>
                                                                <option value="9">LÁZARO CÁRDENAS, MICHOACÁN</option>
                                                                <option value="10">MANZANILLO, COLIMA</option>
                                                                <option value="11">MEXICALI, BAJA CALIFORNIA</option>
                                                                <option value="12">MÉXICO, CIUDAD DE MÉXICO</option>
                                                                <option value="13">NOGALES, SONORA</option>
                                                                <option value="14">NUEVO LAREDO, TAMAULIPAS</option>
                                                                <option value="15">PIEDRAS NEGRAS, COAHUILA DE ZARAGOZA</option>
                                                                <option value="16">TAMPICO, TAMAULIPAS</option>
                                                                <option value="17">TIJUANA, BAJA CALIFORNIA</option>
                                                                <option value="18">TUXPAN, VERACRUZ</option>
                                                                <option value="19">VERACRUZ, VERACRUZ</option>
                                                                <option value="20">PENDIENTE</option>
                                                                <option value="21">AEROPUERTO INTERNACIONAL FELIPE ANGELES</option>
                                                            </select>
                                                            <label htmlFor='floatingInput'></label>
                                                            <span className='text-danger'>{fc_09Map?.idaduanasalidacheck ? fc_09Map?.idaduanasalida : ''}</span>
                                                            {touched.idaduanasalida && errors.idaduanasalida && <div className="text-danger">{errors.idaduanasalida}</div>}
                                                        </div>
                                                    </div>
                                                    <div className='col-xs-12 col-sm-12 col-md-12 col-xl-12 col-xxl-12'>
                                                        <div className="form-floating mb-3">
                                                            <input type="text" className={`form-control ${fc_09Map.observacionescheck !== undefined ? (
                                                                fc_09Map?.observacionescheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='Observaciones'
                                                                // value={observaciones} onChange={e => setobservaciones(e.target.value)} 
                                                                name="observaciones"
                                                                value={values.observaciones}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            <label htmlFor='floatingInput'>Observaciones</label>
                                                            <span className='text-danger'>{fc_09Map?.observacionescheck ? fc_09Map?.observaciones : ''}</span>
                                                            {/*touched.observaciones && errors.observaciones && <div className="text-danger">{errors.observaciones}</div>*/}
                                                        </div>
                                                    </div>
                                                </div>

                                            </Fragment>
                                        ) : paginaActiva === 3 ?
                                            (
                                                <Fragment>
                                                    {
                                                        modoCorreccion &&
                                                        <div className='text-center'>
                                                            {
                                                                observacionesStatus.observacionesProductos !== 0 ?
                                                                    <h6><p style={{ color: 'red' }}><strong>Este apartado tiene observaciones</strong></p></h6>
                                                                    :
                                                                    <h6><p style={{ color: 'green' }}><strong>Este apartado no tuvo observaciones</strong></p></h6>
                                                            }
                                                        </div>
                                                    }
                                                    <div className='row align-items-center'>
                                                        <div className='row mb-2 col-md-12'>
                                                            <h6 className={`text-center ${estilos.labelNaranja}`}>CARACTERISTICAS DEL PRODUCTO</h6>
                                                        </div>

                                                        <TablaProducto api={{ handdleProducto, handdleRemoveProductosPrev, handdleEditProductosPrev, productos }} marcas={marcas} emicioncertificadopromocion={values.emicioncertificadopromocion} productosMap={fc_09ProductosMap}></TablaProducto>

                                                        <div className='col-md-12'>
                                                            <label className="form-label"><b>NOTA:</b> Los productos en los que se agregue un ingrediente
                                                                durante el envasado deberan muestrearse posterior a su envasado para constatar el
                                                                cumplimiento con el apartado 4.3 de la NOM-070-SCFI-2016 a través del Informe de Resultados
                                                                de análisis fisicoquímico.</label>
                                                            <br />
                                                        </div>
                                                    </div>
                                                </Fragment>
                                            ) : paginaActiva === 4 ?
                                                (
                                                    <Fragment>
                                                        {
                                                            modoCorreccion &&
                                                            <div className='text-center'>
                                                                {
                                                                    observacionesStatus.observacionesFilesGenerales !== 0 && observacionesStatus.observacionesFilesProductos ?
                                                                        <h6><p style={{ color: 'red' }}><strong>Este apartado tiene observaciones</strong></p></h6>
                                                                        :
                                                                        <h6><p style={{ color: 'green' }}><strong>Este apartado no tuvo observaciones</strong></p></h6>
                                                                }
                                                            </div>
                                                        }
                                                        <div className='row align-items-center'>
                                                            {
                                                                modoCorreccion &&
                                                                <div className={`${estilos.componenteDocFC_01} col-md-12`}>

                                                                    <DocumentacionFC_09Component> </DocumentacionFC_09Component>
                                                                </div>
                                                            }
                                                            <br />
                                                            <TerminosYCondicionesComponent terminosYCondiciones={terminosYCondiciones} formato={'fc_09'} />
                                                        </div>

                                                        {
                                                            !modoCorreccion ?
                                                                <div>
                                                                    <div className="row mt-4">
                                                                        {

                                                                            modoEdicionBorrador ? (
                                                                                <div className="d-grid gap-2 col-2 mx-auto">
                                                                                    <button type="submit"
                                                                                        // onClick={() => { botonEnviarBorradorFC_09() }}
                                                                                        onClick={() => { botonEnviarSolicitudBorradorFC_09(submitForm), setFunctionSubmitForm({ function: submitForm }), setFunctionResetForm({ function: resetForm }) }}
                                                                                        className={`btn ${estilos.botonNaranjaRedondo}`}
                                                                                        disabled={!terminosYCondiciones}>Enviar borrador</button>
                                                                                </div>
                                                                            ) : (
                                                                                <div className="d-grid gap-2 col-2 mx-auto">
                                                                                    <button type="submit"
                                                                                        // onClick={() => { botonRegistrarFC_09() }}
                                                                                        onClick={() => { botonEnviarSolicitudFC_09(submitForm), setFunctionSubmitForm({ function: submitForm }), setFunctionResetForm({ function: resetForm }) }}
                                                                                        className={`btn ${estilos.botonNaranjaRedondo}`}
                                                                                        disabled={!terminosYCondiciones}>Enviar</button>
                                                                                </div>
                                                                            )
                                                                        }

                                                                    </div>
                                                                </div>
                                                                :
                                                                <div className="row mt-4">
                                                                    <div className="d-grid gap-2 col-2 mx-auto">
                                                                        <button type="submit"
                                                                            // onClick={() => { botonEnviarCorreccionesFC_09() }}
                                                                            disabled={!terminosYCondiciones}
                                                                            onClick={() => { botonEnviarCorreccionesFC_09(submitForm), setFunctionSubmitForm({ function: submitForm }), setFunctionResetForm({ function: resetForm }) }}
                                                                            className={`btn ${estilos.botonNaranjaRedondo}`}>Enviar correcciones</button>
                                                                    </div>

                                                                </div>
                                                        }


                                                        <br />
                                                    </Fragment>
                                                ) :
                                                (
                                                    <Fragment>

                                                    </Fragment>
                                                )
                            }

                            {modalComponent()}
                        </div >
                        {enviado &&
                            <ModalEnviadoCorrectamente folioSolicitud={folioSolicitud}></ModalEnviadoCorrectamente>
                        }
                        {validacion && <ModalCamposObligatorios texto={texto} api={{ resetValores }}></ModalCamposObligatorios>}
                        <BotonAtrasSiguienteComponent botonSiguiente={paginaSiguiente} botonAnterior={paginaAnterior} paginaActiva={paginaActiva} totalDePaginas={paginas.length} valores={values} />
                    </form>
                )}
            </Formik>

        </Fragment>

    )
}

export default withRouter(FormularioFC09BeneficiarioComponent)
